import PetFaq from "../../components/organisms/Pet-Insurance/faq";

const PetInsuranceFaqPage = ({ ...props }) => {
  return <PetFaq />;
};

export default PetInsuranceFaqPage;
